<script setup>
import { storeToRefs } from 'ui.vue3.pinia';
import useCalculatorStore from '../../../store/calculator.js';

const calculator = useCalculatorStore();
const { servicesAvailable } = storeToRefs(calculator);
</script>

<template>
  <template v-if="servicesAvailable.length > 0">
    <hr>
    <p class="cloud-calculator__summary-row" v-for="service in servicesAvailable" :key="service.id">
      <span class="cloud-calculator__summary-label">
        {{ service.name }}:
      </span>
      <span class="cloud-calculator__summary-value" v-html="service.value"/>
    </p>
  </template>
</template>

<style scoped>
.cloud-calculator__summary-row {
  font-size: 14px;

  .cloud-calculator__summary-label,
  .cloud-calculator__summary-value {
    font-size: 1em;
  }
}
</style>
